// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"24ac5168","168":"09527d21","193":"5d425b1c","344":"5b26df88","453":"da14097c","492":"a87949bf","587":"20bb48d3","640":"02e9aa6b","727":"27ccadec","842":"a0cf5e3e","938":"b384654d","963":"d85e0eba"}[chunkId] + ".chunk.js";
};